<section class="beneficios-reforma">
    <h2 class="section-title">Beneficios de la Reforma</h2>
    <p class="section-description">
        La implementación de la Reforma de Pensiones y sus beneficios ya están en
        marcha, acá te contamos cuáles son:
    </p>

    <div class="modal-container">
        <div class="modal-body">
            <div class="sidebar" [class.has-left-overflow]="canScrollLeft"
                [class.has-right-overflow]="canScrollRight">
                <div class="sidebar-content" #benefitsTrack (scroll)="updateScrollState()">
                    <button type="button" *ngFor="let benefit of benefits" class="benefit-item"
                        [class.active]="benefit.key === selectedBenefit" [attr.data-benefit]="benefit.key"
                        (click)="selectBenefit(benefit.key)">
                        <span>{{ benefit.text }}</span>
                        <icon-beneficios-reforma-flecha-menu class="benefit-arrow" aria-hidden="true"></icon-beneficios-reforma-flecha-menu>
                    </button>
                </div>
                <button type="button" class="benefits-arrow benefits-arrow-left" *ngIf="canScrollLeft"
                    aria-label="Ver beneficios anteriores" (click)="scrollBenefits('left')">
                    <icon-beneficios-reforma-flecha-menu aria-hidden="true"></icon-beneficios-reforma-flecha-menu>
                </button>
                <button type="button" class="benefits-arrow benefits-arrow-right" *ngIf="canScrollRight"
                    aria-label="Ver más beneficios" (click)="scrollBenefits('right')">
                    <icon-beneficios-reforma-flecha-menu aria-hidden="true"></icon-beneficios-reforma-flecha-menu>
                </button>
            </div>

            <div class="main-content">
                <div [ngSwitch]="selectedBenefit" style="width: 100%; height: 100%;">

                    <div @fadeInOut style="width: 100%; height: 100%;" *ngSwitchCase="'aumento-pgu'">
                        <app-aumento-pgu style="width: 100%; height: 100%;"></app-aumento-pgu>
                    </div>

                    <div @fadeInOut style="width: 100%; height: 100%;" *ngSwitchCase="'compensacion-mujeres'">
                        <app-compensacion-mujeres style="width: 100%; height: 100%;"></app-compensacion-mujeres>
                    </div>

                    <div @fadeInOut style="width: 100%; height: 100%;" *ngSwitchCase="'ampliacion-seguro-de-lagunas'">
                        <app-ampliacion-seguro-lagunas style="width: 100%; height: 100%;"></app-ampliacion-seguro-lagunas>
                    </div>

                    <div @fadeInOut style="width: 100%; height: 100%;" *ngSwitchCase="'beneficios-cotizados'">
                        <app-beneficios-cotizados style="width: 100%; height: 100%;"></app-beneficios-cotizados>
                    </div>

                    <div @fadeInOut style="width: 100%; height: 100%;" *ngSwitchCase="'ajuste-de-pension'">
                        <app-ajuste-pension style="width: 100%; height: 100%;"></app-ajuste-pension>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>